import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import screenOptions from '../config/screenOptions';
import { LevelStart, LevelOne, LevelTwo, LevelThree, LevelFour, LevelComplete } from '../screens/worker'

const Worker = createStackNavigator();
const WorkerLevel = () => {
  return (
    <Worker.Navigator screenOptions={screenOptions} >
      <Worker.Screen name="Worker Level Start" component={LevelStart} />
      <Worker.Screen name="Worker Level One" component={LevelOne} />
      <Worker.Screen name="Worker Level Two" component={LevelTwo} />
      <Worker.Screen name="Worker Level Three" component={LevelThree} />
      <Worker.Screen name="Worker Level Four" component={LevelFour} />
      <Worker.Screen name="Worker Level Complete" component={LevelComplete} />
    </Worker.Navigator>
)};

export default WorkerLevel;
